// extracted by mini-css-extract-plugin
export default {"root":"Investments_root__OM-Pt","label":"Investments_label__1KC9T"};